import { GetStaticPaths, GetStaticProps, NextPage } from 'next'
import { client } from '../../../apollo/client'
import { Layout } from '../../../components/layout/layout'
import { GlobalProps, withLayoutProps } from '../../../globals/layout'
import { nonNull } from '../../../utils/nonNull'
import { pageQuery } from '../../../utils/pageQuery'

import { gql } from '@apollo/client/core'
import { REVALIDATION_FREQUENCY } from '../../../constants/revalidation'
import { FAQDetail, FAQ_DETAIL_PAGE_QUERY } from '../../../templates/faqDetail'
import { FaqDetailPageQuery, FaqDetailPageQueryVariables } from '../../../templates/faqDetail/__generated__'
import { RETOUR_QUERY } from '../../[...slug]'
import { RetourQuery, RetourQueryVariables } from '../../__generated__/[...slug]'
import { FirstPageFaqsQuery, FirstPageFaqsQueryVariables } from './__generated__/[slug]'


export type FAQDetailPageProps = GlobalProps &{
  data: FaqDetailPageQuery
}

const FAQDetailPage: NextPage<FAQDetailPageProps> = ({ data,  ...layoutProps }) => {
  return (
    <Layout { ...layoutProps }>
      <FAQDetail { ...data } />
    </Layout>
  )
}

export default FAQDetailPage

export const getStaticProps: GetStaticProps<Record<string, unknown>, { slug: string[] }> = async (context) => {
  const uri = `help-and-support/faqs/${context.params?.slug}`
  const { data } = await pageQuery<FaqDetailPageQuery, FaqDetailPageQueryVariables>({
    query: FAQ_DETAIL_PAGE_QUERY,
    variables: { uri },
  }, context)

  const retour = await client.query<RetourQuery, RetourQueryVariables>({
    query: RETOUR_QUERY,
    variables: {
      uri: `/${uri}`,
    },
  })

  const { retourResolveRedirect } = retour?.data

  if (retourResolveRedirect?.redirectDestUrl !== null && typeof retourResolveRedirect?.redirectDestUrl === 'string') {
    return {
      redirect: {
        destination: retourResolveRedirect?.redirectDestUrl,
        permanent: false,
      },
    }
  }

  return withLayoutProps({
    path: `/${uri}`,
  }, data.entry ? {
    props: { data },
    revalidate: REVALIDATION_FREQUENCY,
  } : {
    notFound: true,
  })
}

const FIRST_PAGE_FAQS_QUERY = gql`
  query FirstPageFaqsQuery {
    entries(section: "faqs", limit: 12) {
      slug
    }
  }
`

export const getStaticPaths: GetStaticPaths = async () => {
  const { data } = await client.query<FirstPageFaqsQuery, FirstPageFaqsQueryVariables>({
    query: FIRST_PAGE_FAQS_QUERY,
  })

  return ({
    paths: nonNull(data.entries?.map(entry => entry?.slug ? `/help-and-support/faqs/${entry.slug}` : undefined) ?? []),
    fallback: 'blocking',
  })
}